export var classNames = function () {
    var classNames = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        classNames[_i] = arguments[_i];
    }
    if (!classNames || classNames.length === 0)
        return '';
    return classNames.join(' ');
};
//# sourceMappingURL=style-class.utils.js.map